import { SettingsSectionHeader } from '../common';
import { displayContent } from '../common/content';
import { RokuBody } from './formFields/rokuFormFields/Body';
import { RokuHeader } from './formFields/rokuFormFields/Header';
import { RokuActionButtons } from './formFields/rokuFormFields/ActionButtons';
import { RokuImageUrl } from './formFields/rokuFormFields/ImageUrl';
import { RokuBackgroundColor } from './formFields/rokuFormFields/BackgroundColor';
import { RokuButtonFont } from './formFields/rokuFormFields/ButtonFont';
import { RokuHeaderFont } from './formFields/rokuFormFields/HeaderFont';
import { RokuBodyFont } from './formFields/rokuFormFields/BodyFont';

export const RokuFields = (): JSX.Element => {
  return (
    <>
      <SettingsSectionHeader>{displayContent.headerContent}</SettingsSectionHeader>
      <RokuImageUrl />
      <RokuHeader />
      <RokuHeaderFont />
      <RokuBody />
      <RokuBodyFont />
      <RokuActionButtons />
      <RokuButtonFont />
      <RokuBackgroundColor />
    </>
  );
};
